<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/notifications/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ساخت اعلان جدید</v-card-title>
      <v-card-text>
        <!--        FILTERS-->
        <v-row>
          <v-col cols="2">
            <v-select label="گروه را انتخاب کنید"
                      :items="[{value:'students',text:'هنرجویان'},{value:'instructors',text:'مربیان'}]"
                      item-text="text" item-value="value"
                      color="black" v-model="selectedGroup" @change="clearStudentsAndInstructors()">
            </v-select>
          </v-col>
          <v-col>
            <v-select multiple label="دوره را انتخاب کنید" :items="courses"
                      item-text="title" item-value="id"
                      color="black" v-model="selectedCourses" @change="getClasses()">
            </v-select>
          </v-col>
          <v-col>
            <v-autocomplete multiple label="کلاس را انتخاب کنید" :items="classes"
                            item-text="title" item-value="id"
                            color="black" v-model="selectedClasses"
                            @change="selectedGroup === 'instructors' ?  getInstructors() : getStudents()">
            </v-autocomplete>
          </v-col>
          <v-col v-if="selectedGroup === 'students'">
            <v-autocomplete multiple label="هنرجویان را فیلتر کنید" :items="students"
                            item-text="name" item-value="id"
                            color="black" v-model="selectedStudents">
            </v-autocomplete>
          </v-col>
          <v-col v-if="selectedGroup === 'instructors'">
            <v-autocomplete multiple label="مربیان را فیلتر کنید" :items="instructors"
                            item-text="name" item-value="id"
                            color="black" v-model="selectedInstructors">
            </v-autocomplete>
          </v-col>
        </v-row>
        <!--        OTHER FIELDS-->
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="notification.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-select
                label="فوریت اعلان را مشخص کنید"
                :items="[{value:'high',text:'بالا'},{value:'normal',text:'متوسط'},{value:'low',text:'پایین'}]"
                v-model="notification.priority"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-select
                label="بخش اعلان را مشخص کنید"
                :items="sections"
                v-model="notification.section"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="2">
            <v-color-picker
                label="رنگ اعلان را مشخص کنید"
                v-model="notification.color"
                item-value="value"
                item-text="text"
                color="black"
            ></v-color-picker>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                label="اعلان پس از ورود به کاربر نمایش داده شود؟"
                v-model="notification.show_after_login"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="اعلان با صدا پخش شود؟"
                v-model="notification.has_sound_alert"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="اعلان در زمان دیگری ارسال شود؟"
                v-model="notification.has_schedule"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                @change="changeHasAttachment()"
                label="اعلان فایل ضمیمه دارد؟"
                v-model="notification.has_attachment"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="3">
            <v-checkbox
                label="اعلان در وضعیت پیش نویس ذخیره شود؟"
                v-model="notification.status"
                color="black"
                value="draft"
            >
            </v-checkbox>
          </v-col>
          <v-col v-if="notification.has_schedule" cols="2">
            <vue-persian-datetime-picker color="black" v-model="notification.send_at"
                                         type="datetime"
                                         custom-input="#send_at"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ و زمان ارسال اعلان" v-model="notification.send_at" id="send_at"
                          color="black">
            </v-text-field>
          </v-col>
          <v-col v-if="notification.has_attachment" cols="2">
            <v-select
                label="نوع فایل اعلان را مشخص کنید"
                :items="attachment_types"
                v-model="notification.attachment_type"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="4" v-if="notification.has_attachment">
            <v-text-field label="فایل"
                          @click="fileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="notification.url"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="notification.content" label="محتوای اعلان"></v-textarea>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="fileDialog" max-width="50vw">
      <drag-and-drop module="notification" ref="file-uploader" @closeUploadFileDialog="fileDialog = false"
                     @changeFile="notification.url = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "NotificationCreate",
  components: {DragAndDrop, VuePersianDatetimePicker},
  data() {
    return {
      fileDialog: false,
      sections: [
        {value: 'concert', text: 'کنسرت'},
        {value: 'change_program', text: 'تغییر در برنامه'},
        {value: 'news', text: 'خبر'},
        {value: 'offer', text: 'پیشنهاد'},
        {value: 'general', text: 'عمومی'},
      ],
      colors: [
        {value: 'white', text: 'سفید'},
        {value: '#6ea9f2', text: 'آبی درکی'},
        {value: 'black', text: 'مشکی'},
        {value: 'orange', text: 'نارنجی'},
        {value: 'red', text: 'قرمز'},
      ],
      attachment_types: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
        {value: 'zip', text: 'فایل فشرده'},
      ],
      courses: [],
      classes: [],
      students: [],
      instructors: [],
      selectedCourses: [],
      selectedClasses: [],
      selectedStudents: [],
      selectedInstructors: [],
      selectedGroup: 'students',
      notification: {
        title: null,
        content: null,
        instructor_ids: null,
        student_ids: null,
        priority: 'normal',
        section: 'general',
        color: '#6ea9f2',
        has_sound_alert: false,
        has_attachment: false,
        show_after_login: false,
        has_schedule: false,
        url: null,
        attachment_type: null,
        send_at: null,
        status: 'sent'
      }
    }
  },
  mounted() {
    this.getCourses()
  },
  methods: {
    changeHasAttachment() {
      if (!this.notification.has_attachment) {
        this.notification.url = null
        this.notification.attachment_type = null
      }
    },
    store() {
      if (!this.notification.status) {
        this.notification.status = 'draft'
      }
      this.notification.instructor_ids = this.selectedInstructors
      this.notification.student_ids = this.selectedStudents
      window.axios.post('notification/crud/create', this.notification).then(() => {
        this.clear()
        this.openSnackbar("اعلان جدید با موفقیت ساخته شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.notification = {
        title: null,
        content: null,
        instructor_id: null,
        admin_id: null,
        student_id: null,
        priority: null,
        section: null,
        color: null,
        has_sound_alert: null,
        has_attachment: null,
        show_after_login: null,
        has_schedule: null,
        url: null,
        attachment_type: null,
        send_at: null,
        status: null,
      }
    },
    clearStudentsAndInstructors() {
      this.selectedCourses = [];
      this.selectedClasses = [];
      this.selectedInstructors = [];
      this.selectedStudents = [];
    },
    getCourses() {
      let url = '/course/crud/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.courses = res.data.data.data
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getClasses() {
      window.axios.post('/class/crud/filter?per_page=1000', {
        course_ids: this.selectedCourses
      }).then((res) => {
        this.classes = res.data.data.data
        this.selectedClasses = []
        this.classes.forEach((item) => {
          this.$set(this.selectedClasses, this.selectedClasses.length, item.id)
        })
        if (this.selectedGroup === 'instructors') {
          this.getInstructors()
        } else {
          this.getStudents()
        }
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getInstructors() {
      window.axios.post('/admin/instructor/filter?per_page=1000', {
        course_ids: this.selectedCourses,
        class_ids: this.selectedClasses
      }).then((res) => {
        this.instructors = res.data.data.data
        this.selectedStudents = []
        this.selectedInstructors = []
        this.instructors.forEach((item) => {
          this.$set(this.selectedInstructors, this.selectedInstructors.length, item.id)
        })
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getStudents() {
      window.axios.post('/admin/student/filter?per_page=1000', {
        course_ids: this.selectedCourses,
        class_ids: this.selectedClasses
      }).then((res) => {
        this.students = res.data.data.data
        this.selectedStudents = []
        this.selectedInstructors = []
        this.students.forEach((item) => {
          this.$set(this.selectedStudents, this.selectedStudents.length, item.id)
        })
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>